const cranes = [
    {
        "id": 1,
        "name": "Pick and Carry Hydraulic Cranes",
        "filedid": "pc",
        "products": [
            {
                "id": 1,
                "name": "TRX 2319",
                "quantity": "1",
                "capacity": "23MT",
                "boomlength": "49 ft",
                "Image": "/product/cranes/pc/trx-2319.png",
                "pdf": "/pdf/cranes/pc/TRX-2319.pdf"
            },
            {
                "id": 2,
                "name": "ACE CRANE",
                "quantity": 24,
                "capacity": "11MT",
                "boomlength": "Standard + single extension",
                "Image": "/product/cranes/pc/ace-crane.png",
                "pdf": "/pdf/cranes/pc/ACE-CRANE.pdf"
            },
            {
                "id": 3,
                "name": "ACE CRANE",
                "quantity": 24,
                "capacity": "12MT",
                "boomlength": "11.5mts + Double Extension",
                "Image": "/product/cranes/pc/ace-crane1.png",
                "pdf": "/pdf/cranes/pc/ACE-CRANE-1.pdf"
            }
        ]
    },
    {
        "id": 2,
        "name": "All Terrain Cranes",
        "filedid": "al_terrain",
        "products": [
            {
                "id": 1,
                "name": "XCMG XCA 350",
                "quantity": 1,
                "capacity": "350 Ton",
                "boomlength": "Main boom 15.5m + 82m and 14.7m~42m",
                "Image": "/product/cranes/al_terrain/xcmg-xca-350-300x225.webp",
                "pdf": "/pdf/cranes/al_terrain/XCA350_Y-Load-Chart.pdf"
            },
            {
                "id": 2,
                "name": "SAC 1600 S",
                "quantity": 1,
                "capacity": "160 Ton",
                "boomlength": "Main boom 73m + 32m",
                "Image": "/product/cranes/al_terrain/SAC-1600-S-300x139.webp",
                "pdf": "/pdf/cranes/al_terrain/SAC-1600S-Chart.pdf"
            },
            {
                "id": 3,
                "name": "STC 1100 S",
                "quantity": 1,
                "capacity": "110 Ton",
                "boomlength": "Main boom 59m + 27m",
                "Image": "/product/cranes/al_terrain/stc-1100-s-300x225.webp",
                "pdf": "/pdf/cranes/al_terrain/Sany-1100-S-Chart.pdf"
            },
            {
                "id": 4,
                "name": "XCMG XCA 160",
                "quantity": 1,
                "capacity": "160 Ton",
                "boomlength": "Main boom 78m + 17m",
                "Image": "/product/cranes/al_terrain/xcmg-xca-160-300x225.webp",
                "pdf": "/pdf/cranes/al_terrain/XCA160-Load-Chart.pdf"
            },
            {
                "id": 5,
                "name": "XCMG XCT 110",
                "quantity": 1,
                "capacity": "110 Ton",
                "boomlength": "12.4m ~ 59m",
                "Image": "/product/cranes/al_terrain/xcmg-xct-110-300x169.webp",
                "pdf": "/pdf/cranes/al_terrain/XCT110-Load-Chart.pdf"
            },
            {
                "id": 6,
                "name": "XCMG-QAY 220",
                "quantity": 2,
                "capacity": "220 Ton",
                "boomlength": "73m & base boom: 13.4 m",
                "Image": "/product/cranes/al_terrain/xcmg-qay-220-300x169.webp",
                "pdf": "/pdf/cranes/al_terrain/xcmg_qay_220_load_chart.pdf"
            },
            {
                "id": 7,
                "name": "Liebherr LTM 1400-7.1",
                "quantity": 1,
                "capacity": "400MT",
                "boomlength": "198+277ft",
                "Image": "/product/cranes/al_terrain/ltm-1400.webp",
                "pdf": "/pdf/cranes/al_terrain/ltm1400-loadcharts.pdf"
            },
            {
                "id": 10,
                "name": "DEMAG AC 80",
                "quantity": 1,
                "capacity": "80 MT",
                "boomlength": "165+58 ft",
                "Image": "/product/cranes/al_terrain/demag-ac-80.webp",
                "pdf": "/pdf/cranes/al_terrain/DEMAG-AC-80.pdf"
            },
            {
                "id": 11,
                "name": "Liebherr LTM 1070",
                "quantity": 2,
                "capacity": "70MT",
                "boomlength": "122+56ft",
                "Image": "/product/cranes/al_terrain/ltm-1070.webp",
                "pdf": "/pdf/cranes/al_terrain/LEIBHERR-1070.pdf"
            }
        ]
    },
    {
        "id": 3,
        "name": "Truck Mounted Cranes",
        "filedid": "truck_mounted",
        "products": [
            {
                "id": 1,
                "name": "TMS 750",
                "quantity": 1,
                "capacity": "40 Ton",
                "boomlength": "Mainboom 43m and 33m ~ 10m",
                "Image": "/product/cranes/truck_mounted/TMS-750-300x190-1.webp",
                "pdf": "/pdf/cranes/truck_mounted/TMS_750MKII-Load-Chart.pdf"
            },
            {
                "id": 2,
                "name": "STC 800",
                "quantity": 2,
                "capacity": "80 Ton",
                "boomlength": "Mainboom 45m and 45m~16m",
                "Image": "/product/cranes/truck_mounted/80-TON-300x225-1.webp",
                "pdf": "/pdf/cranes/truck_mounted/STC800.pdf"
            },
            {
                "id": 3,
                "name": "STC 450C",
                "quantity": 4,
                "capacity": "45 Ton",
                "boomlength": "Main boom 43m and 43m~9m",
                "Image": "/product/cranes/truck_mounted/45-TON-300x227-1.webp",
                "pdf": "/pdf/cranes/truck_mounted/STC450C-LOADCHART.pdf"
            },
            {
                "id": 4,
                "name": "TIL TMS 850",
                "quantity": 2,
                "capacity": "50 MT",
                "boomlength": "11-41.3mtr",
                "Image": "/product/cranes/truck_mounted/til-tms-850-300x225-1.webp",
                "pdf": "/pdf/cranes/truck_mounted/til-tms-850.pdf"
            },
            {
                "id": 5,
                "name": "TIL TMS 880",
                "quantity": 1,
                "capacity": "80MT",
                "boomlength": "12.1-43.8mtr",
                "Image": "/product/cranes/truck_mounted/til-tms-880-2-300x239-1.webp",
                "pdf": "/pdf/cranes/truck_mounted/til-tms-880.pdf"
            },
            {
                "id": 6,
                "name": "DEMAG AC-40",
                "quantity": 2,
                "capacity": "40MT",
                "boomlength": "103 + 45 ft",
                "Image": "/product/cranes/truck_mounted/demag-ac-40-300x225-1.webp",
                "pdf": "/pdf/cranes/truck_mounted/DEMAG-AC-40.pdf"
            }
        ]
    },
    {
        "id": 4,
        "name": "Chain Mounted Crawler Mounted Cranes",
        "filedid": "chain_mounted",
        "products": [
            {
                "id": 1,
                "name": "SCI850A",
                "quantity": 1,
                "capacity": "85 Ton",
                "boomlength": "Mainboom 57m and 48m~18m",
                "Image": "/product/cranes/chain_mounted/85-TON-PHOTO-179x300-1.webp",
                "pdf": "/pdf/cranes/chain_mounted/SCI850A-LOAD-CHART.pdf"
            },
            {
                "id": 2,
                "name": "SCC 1000A-6",
                "quantity": 1,
                "capacity": "100 Ton",
                "boomlength": "",
                "Image": "/product/cranes/chain_mounted/SCC-1000-A-6-300x135-1.webp",
                "pdf": "/pdf/cranes/chain_mounted/SCC-1000A-6.pdf"
            },
            {
                "id": 3,
                "name": "Manitowac 2250",
                "quantity": 1,
                "capacity": "300 MT",
                "boomlength": "300 ft",
                "Image": "/product/cranes/chain_mounted/manitawoc-2250-270x300-1.webp",
                "pdf": "/pdf/cranes/chain_mounted/MANITOWOC-2250.pdf"
            },
            {
                "id": 4,
                "name": "LIEBHERR LR1280",
                "quantity": 1,
                "capacity": "280 MT",
                "boomlength": "181+313ft",
                "Image": "/product/cranes/chain_mounted/liebherr-271x300-1.webp",
                "pdf": "/pdf/cranes/chain_mounted/liebherr_lr1280.pdf"
            },
            {
                "id": 6,
                "name": "XCMG-XGC 150",
                "quantity": 1,
                "capacity": "150 MT",
                "boomlength": "76 + 31 mtr",
                "Image": "/product/cranes/chain_mounted/IMG-20200215-WA0001-150x300-1.webp",
                "pdf": "/pdf/cranes/chain_mounted/XCMG-load-chart.pdf"
            },
            {
                "id": 7,
                "name": "Kobelco-CKL 1350i",
                "quantity": 1,
                "capacity": "150 MT",
                "boomlength": "76 + 31 mt",
                "Image": "/product/cranes/chain_mounted/Kobelco-CKL-1350i-picture-1-225x300-1.webp",
                "pdf": "/pdf/cranes/chain_mounted/LOAD-CHART-OF-KOBELCO-1.pdf"
            }
        ]
    },
    {
        "id": 5,
        "name": "Mobile Tower Crane",
        "filedid": "mobile_tower",
        "products": [
            {
                "id": 1,
                "name": "MK 80",
                "quantity": 1,
                "capacity": "8 Ton",
                "boomlength": "Tower height 28 mts, Zip length 42 mts",
                "Image": "/product/cranes/mobile_tower/mk80-300x225-1.webp",
                "pdf": "/pdf/cranes/mobile_tower/mk80-1.pdf"
            }
        ]
    }
];
export default cranes;